export default "__VITE_ASSET__IoVynzB7__"